export default "__VITE_ASSET__OswisaCj__"